import React, { useEffect } from "react";
import {
  EducationContainer,
  EducationTitle,
  EducationWrapper,
  EducationCard,
  EducationCardImg,
  EducationCardMeta,
  EducationCardTitle,
  EducationCardSubTitle,
  EducationCardDesc,
  ImgWrapper,
  EducationCardSubTitleBorder,
} from "./Education.elements";
import twitter from "../../images/bird.png";
import mern from "../../images/MERN.jpg";
import socketio from "../../images/socketio.jpg";
import html from "../../images/htmlcss.png";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Education({ light }) {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <EducationContainer
        className="resume"
        id="education"
        data-aos="fade-up"
        data-aos-offset="300"
        data-aos-easing="ease-in-sine"
      >
        <EducationTitle light={light}> FORMACIÓN ADICIONAL</EducationTitle>
        <EducationWrapper>
          <EducationCard light={light}>
            <ImgWrapper>
              <EducationCardImg src={twitter} alt="twitter" />
            </ImgWrapper>
            <EducationCardMeta>
              <EducationCardTitle light={light}>
                DESARROLLO WEB FULL-STACK CON MERN 3.0
              </EducationCardTitle>
              <EducationCardSubTitle light={light}>
                Curso de Enseñanzas Propias | Marzo 2021
              </EducationCardSubTitle>
              <EducationCardSubTitleBorder />
              <EducationCardDesc light={light}>
                El stack o pila MERN permite la creación sólida de aplicaciones
                web dinámicas de fácil mantenimiento utilizando las tecnologías
                MongoDB, ExpressJS, ReactJS y NodeJS, de ahí sus iniciales.
              </EducationCardDesc>
            </EducationCardMeta>
          </EducationCard>
          <EducationCard light={light}>
            <ImgWrapper>
              <EducationCardImg src={mern} alt="twitter" />
            </ImgWrapper>
            <EducationCardMeta>
              <EducationCardTitle light={light}>
                Web Personal MERN Full Stack: MongoDB, Express, React y Node
              </EducationCardTitle>
              <EducationCardSubTitle light={light}>
                Curso Udemy | Julio 2021
              </EducationCardSubTitle>
              <EducationCardSubTitleBorder />
              <EducationCardDesc light={light}>
                Desarrollo Full Stack, creando una web personal con el Stack
                MERN (MongoDB, Express, React y Node) la ultima tecnología.
                Curso creado por Agustín Navarro Galdón.
              </EducationCardDesc>
            </EducationCardMeta>
          </EducationCard>
          <EducationCard light={light}>
            <ImgWrapper>
              <EducationCardImg src={socketio} alt="twitter" />
            </ImgWrapper>
            <EducationCardMeta>
              <EducationCardTitle light={light}>
                React: Aplicaciones en tiempo real con Socket-io
              </EducationCardTitle>
              <EducationCardSubTitle light={light}>
                Curso Udemy | Marzo 2021
              </EducationCardSubTitle>
              <EducationCardSubTitleBorder />
              <EducationCardDesc light={light}>
                Crear aplicaciones en tiempo real de Mapas, colas, tickets de
                trabajo, gráficas y chat usando socket-io. Crea un CRUD completo
                en tiempo real; tu propio backend server que mezcla websockets
                con Rest endpoints; Conecta React con un Socket-io backend
                server; Modifica bases de datos basados en eventos sockets.
                Curso creado por Fernando Herrera.
              </EducationCardDesc>
            </EducationCardMeta>
          </EducationCard>
          <EducationCard light={light}>
            <ImgWrapper>
              <EducationCardImg src={html} alt="twitter" />
            </ImgWrapper>
            <EducationCardMeta>
              <EducationCardTitle light={light}>
                Aprende a crear webs desde cero con HTML Y CSS
              </EducationCardTitle>
              <EducationCardSubTitle light={light}>
                Curso Udemy | Julio 2020
              </EducationCardSubTitle>
              <EducationCardSubTitleBorder />
              <EducationCardDesc light={light}>
                Aprende a crear páginas web completas en unas horas, utilizando
                HTML y CSS. Asentarás las bases para iniciar una carrera como
                desarrollador web. Curso creado por Guillermo Rincón García.
              </EducationCardDesc>
            </EducationCardMeta>
          </EducationCard>
        </EducationWrapper>
      </EducationContainer>
    </>
  );
}
